import { createFileRoute } from '@tanstack/react-router'
import { FabricStreamsPage, type FabricStreamsParams } from '@bloo-team/product-fabric'

/**
 * Composer shim (S5.0, docs/modularization.md §Route mounting): route
 * infrastructure stays in the app's tree; the surface lives in
 * @bloo-team/product-fabric. `?open=<stream>` deep-links the stream panel
 * (Storage's capacity rows pivot here — docs/storage-requirements.md §Pivots);
 * an unknown name opens nothing. `?filter=` pre-selects a list filter
 * (Datafabric · Overview's checks link here —
 * docs/fabric-overview-requirements.md §The checks); anything but a known
 * filter is dropped, and `all` is its absence.
 */
type StreamsUrlFilter = NonNullable<FabricStreamsParams['filter']>

const URL_FILTERS: readonly StreamsUrlFilter[] = ['with-workbooks', 'idle', 'silent', 'unmapped']

const isUrlFilter = (v: unknown): v is StreamsUrlFilter =>
  typeof v === 'string' && (URL_FILTERS as readonly string[]).includes(v)

function StreamsRoute() {
  const { clusterId, scopeId } = Route.useParams()
  const { open, filter } = Route.useSearch()
  return <FabricStreamsPage clusterId={clusterId} scopeId={scopeId} open={open} filter={filter} />
}

export const Route = createFileRoute('/$clusterId/$scopeId/fabric/streams')({
  validateSearch: (search: Record<string, unknown>): FabricStreamsParams => ({
    open: typeof search.open === 'string' && search.open.trim() ? search.open.trim() : undefined,
    filter: isUrlFilter(search.filter) ? search.filter : undefined,
  }),
  component: StreamsRoute,
})
